import { Component, OnInit } from '@angular/core';
import { SearchOpeBiCriteria } from 'src/app/models/SearchOpeBiCriteria';
import { Region } from 'src/app/models/Region';
import { RegionService } from 'src/app/services/region/region.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { DataStateEnum } from 'src/app/enumeration/dataState.enum';
import { Subject, of } from 'rxjs';
import { DepartementService } from 'src/app/services/departement/departement.service';
import { Departement } from 'src/app/models/Departement';
import { Ville } from 'src/app/models/Ville';
import { VilleService } from 'src/app/services/ville/ville.service';
import { TypeLot } from 'src/app/models/TypeLot';
import { TypeLotService } from 'src/app/services/typeLot/type-lot.service';
import { biTypologieDto } from 'src/app/models/biTypologieDto';
import { TypologieLotService } from 'src/app/services/typologieLot/typologie-lot.service';
import { Etage } from 'src/app/models/Etage';
import { EtageService } from 'src/app/services/bi/etage/etage.service';
import { StatutLotService } from 'src/app/services/statutLot/statut-lot.service';
import { StatutLot } from 'src/app/models/StatutLot';
import { TvaLotService } from 'src/app/services/tvaLot/tva-lot.service';
import { TvaLot } from 'src/app/models/TvaLot';
import { SearchOpeCriteria } from 'src/app/models/SearchOpeCriteria';
import { Router } from '@angular/router';
import { depbyregion } from 'src/app/models/depByRgion';
import { Ope } from 'src/app/models/Ope';
import { SidebarService } from 'src/app/services/sideBare.service';
import { OpeService } from 'src/app/services/ope/ope.service';
import { FormControl } from '@angular/forms';
import { SelectModule } from "primeng/select";
import { MultiSelectModule } from 'primeng/multiselect';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SliderModule } from 'primeng/slider';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';

interface Dummy {
  name: string;
  value: string;
}

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  imports : [SelectModule,MultiSelectModule,CommonModule,FormsModule,SliderModule,ButtonModule,ProgressBarModule,RadioButtonModule],
  styleUrls: ['./global-search.component.scss']
  
})

export class GlobalSearchComponent implements OnInit {



  motCle: string = '';
  budget: number[] = [0, 4000000];
  dateLivraison: number[] = [0, 60];
  maxbud: number = 4000000;
  regions!: Region[];
  selectedRegion!: Region;
  departements: Departement[] | undefined;
  departementbyregion: depbyregion[] | undefined;
  selectedDepartement: Departement[] = [];
  filteredVilles: Ville[] | any;
  selectedVille!: Ville[] | any;
  typesLot: TypeLot[] | undefined;
  selectedTypeLot!: TypeLot;
  typologiesLot: biTypologieDto[] | undefined;
  selectedTypologieLot: biTypologieDto | undefined;
  etages: Etage[] = [{ etage: '' }];
  selectedEtage: Etage | undefined;
  statusLot: StatutLot[] | undefined;
  selectedStatutLot: StatutLot | undefined;
  tvasLot: TvaLot[] | undefined;
  selectedTvaLot: TvaLot | undefined;
  radio!: boolean;
  searchCritere!: SearchOpeBiCriteria | undefined;
  searchCrit!: SearchOpeCriteria;
  montag!: HTMLElement;
  first!: HTMLElement;
  container: boolean = false;
  listope: Ope[] = [];
  criterisa!: SearchOpeCriteria;
  loader = true;
  showError: boolean = false;
  error: string = "MES MSG";
  showErrorTechnique: boolean = false;
  spinner: any;
  showprogressbar: boolean = false;
  private destroy$!: Subject<boolean>;
  searchControl = new FormControl();
  dtoVile!: Ville;
  stringlistcode: string[] = [];
  constructor(private opeservice: OpeService, private _sidebar: SidebarService, public sharedCritereSerice: shareOpeSevices, private regionService: RegionService, private departementService: DepartementService,
    private villeService: VilleService, private typeLotService: TypeLotService, private typologieLotService: TypologieLotService,
    private etageService: EtageService, private statutLotService: StatutLotService, private tvaLotService: TvaLotService, private router: Router, public share: shareOpeSevices) {
    this.searchCritere = new SearchOpeBiCriteria();
    this.searchCrit = new SearchOpeCriteria();
  }

  ngOnInit() {
    this.searchCrit = new SearchOpeCriteria();
    this.getAllRegions();
    this.getAllDepartement();
    this.getAllcities()
    this.getTypeLot();
    this.getTypologieLot();
    this.getEtages();
    this.getAllStatut();
    this.getAllTva();
    this.selectedDepartement.shift();
    this.share.showprogressbar = false;
    this.searchCrit.codesDepartement.length = 0;
    this.selectedRegion = { codeReg: '', nomReg: '' };
    this.motCle = '';
    this.selectedEtage = { etage: '' };
    this.selectedTypeLot = { codeType: '', type: '' };
    this.selectedStatutLot = { codeStatut: 0, libelleStatut: '' };
    this.selectedDepartement.length = 0;
    this.etages = [];
    this.share.callApi = false;
    this.selectedVille = [];
    this.recherche(null);
  }

  getAllRegions() {
    this.regionService.getAllRegion().subscribe({
      next: ((data: Region[]) => {
        this.regions = data;
      }),
      error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    });
  }

  getAllDepartement() {
    this.departementService.getAllDepartement().subscribe({
      next: ((data: Departement[]) => {
        this.departements = data;
      }),
      error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    });
  }

  getDepartementByRegion(code: any) {
    this.departementService.getAllDepartementsByRegion(code).subscribe({
      next: ((data: depbyregion[]) => {
        this.departementbyregion = data;
        this.departements = [];
        this.departementbyregion.forEach(res => {
          this.departements?.push({
            nomDep: res.nomDep,
            codeDep: res.codeDep
          })
        })

      }),
      error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    });

  }

  onChangeRegion() {
    this.getDepartementByRegion(this.selectedRegion.codeReg);
    this.selectedVille = [];
    this.selectedDepartement = [];
    this.villeService.getAllcitiesbyRegion(Number(this.selectedRegion.codeReg)).subscribe(
      data => {
        this.filteredVilles = data;
        this.filteredVilles = this.removeDuplicates(this.filteredVilles, 'ville');
      }
    )
  }


  onchangeVilleDeparatement() {
    this.selectedVille = [];
    this.filteredVilles = []
    this.selectedDepartement.forEach(element => {
      this.selectedVille.length = 0;
      this.villeService.getCitiesByDep(element.codeDep).subscribe(
        res => {
          res.forEach(elem => {

            this.filteredVilles.push(elem);
            this.filteredVilles = this.removeDuplicates(this.filteredVilles, 'ville');
          })
        }
      )
    })
    if (this.selectedDepartement.length === 0) {
      this.getAllcities();
      this.selectedVille = [];
    }
    if (this.selectedDepartement.length === 0 && this.selectedRegion != null) {
      this.onChangeRegion();
      this.selectedVille = [];
    }
  }
  // filterVille(event: AutoCompleteCompleteEvent) {
  //   let filtered: Ville[] = [];
  //   let nom = event.query;


  //   if (nom.length > 2)
  //     this.villeService.getVilleByNom(nom).subscribe({

  //       next: ((data: Ville[]) => {
  //         this.filteredVilles = data;

  //       }),
  //       error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })

  //     });

  // }
  getAllcities() {
    this.villeService.getAllcities().subscribe(data => {
      // this.filteredVilles = data;
      this.filteredVilles = this.removeDuplicates(data, 'ville');
    })
  }
  removeDuplicates(myArray: any[], Prop: string) {
    return myArray.filter((obj: any, pos: number, arr: any[]) => {
      return arr.map((mapObj: any) => mapObj[Prop as keyof typeof mapObj]).indexOf(obj[Prop as keyof typeof obj]) === pos;
    });
  }
  getTypeLot() {
    https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8182/type-lot/all
    this.typeLotService.getAllTypeLot().subscribe({
      next: ((data: TypeLot[]) => {
        this.typesLot = data;
      }),
      error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })

    });

  }

  getTypologieLot() {
    this.typologieLotService.getAllTypologieLot().subscribe({

      next: ((data: biTypologieDto[]) => {
        this.typologiesLot = data;
      }),
      error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    }
    );
  }
  getEtages() {
    this.etageService.getEtagefromsource().subscribe({
      next: ((data: Etage[]) => {
        this.etages = data;
        this.etages.shift();  //  this.searchControl.valueChanges.pipe(

      }),
      error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
    }
    );
  }

  getAllStatut() {
    this.statutLotService.getAllStatutLot().subscribe(
      {
        next: ((data: StatutLot[]) => {
          this.statusLot = data;
        }),
        error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
      }

    )
  }

  getAllTva() {
    this.tvaLotService.getAllTvasLot().subscribe(
      {
        next: ((data: TvaLot[]) => {
          this.tvasLot = data;
        }),
        error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
      }

    )
  }
  public arrondir(data: number) {

    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(data);

  }
  recherche(event: any) {
    this.share.affichenotfound = false;
    this.share.showprogressbar = true;
    this.container = true
    // pupolate searchcriteria 
    this.searchCrit.motCle = this.motCle;
    this.searchCrit.region = this.selectedRegion?.codeReg;
    this.searchCrit.codesDepartement.length = 0;
    this.searchCrit.villes = '';
    this.deselectDepforsearch(this.selectedDepartement);
    this.selectedDepartement?.forEach(
      (a: Departement) => {
        this.searchCrit.codesDepartement.push(a.codeDep);
      });

    this.searchCrit.codeCategories = Number(this.selectedTypeLot?.codeType!)
    this.searchCrit.codeTypologie = Number(this.selectedTypologieLot?.codeTypologie!);
    this.searchCrit.etage = this.selectedEtage?.etage!;
    this.searchCrit.surfaceExterne = this.radio;
    this.searchCrit.budget = this.budget;
    this.searchCrit.nbmoisLivraison = this.dateLivraison;
    this.searchCrit.statutLot = this.selectedStatutLot?.codeStatut!;
    this.searchCrit.codeTva = Number(this.selectedTvaLot?.codeTva!);
    this.selectedVille?.forEach((element: { ville: any; }) => {
      this.searchCrit.villes = element.ville;
    });
    //this.selectedVille. = this.dtoVile;
    //this.searchCrit.villes =
    /*this.searchCrit = new SearchOpeCriteria({motCle:this.motCle,
    region  : ""+this.selectedRegion?.code,
    codesDepartement:codeappt,
    villes  : this.selectedVille?.nom!,
    codeTypologie : this.selectedTypeLot?.code!,
    codeCategories  : this.selectedTypologieLot?.code!,
    etage  : this.selectedEtage?.niveau!,
    surfaceExterne : this.radio=="Oui",
    budget : this.budget,
    nbmoisLivraison  : this.dateLivraison,
    statutLot  : this.selectedStatutLot?.code!,
    codeTva  : this.selectedTvaLot?.code!});
    */
    this.sharedCritereSerice.sendSearchCrit(this.searchCrit);
  }

  initSearchCrit() {

    this.share.showprogressbar = false;
    this.searchCrit.codesDepartement.length = 0;
    this.radio = true;
    this.selectedRegion = { codeReg: '', nomReg: '' };
    this.motCle = '';
    this.selectedEtage = { etage: '' };
    this.selectedTypeLot = { codeType: '0', type: '' };
    this.selectedStatutLot = { codeStatut: 0, libelleStatut: '' };
    this.selectedDepartement.length = 0;
    this.etages = [];
    this.selectedVille = [];

    this.getTypeLot();
    this.getAllStatut();
    this.getEtages();
    this.getAllTva();
    this.selectedTvaLot = { codeTva: '', tauxTva: 0 },
      this.getAllcities();
    this.getAllDepartement();
    this.getAllRegions;
    this.getTypologieLot();
    this.budget = [0, 4000000];
    this.dateLivraison = [0, 60];
    this.selectedTypologieLot = {
      codeTypologie: '',
      typologie: '',
      codeType: ''
    };
    const sasa = document.getElementById("global-search")
    //sasa?.scrollIntoView({ behavior: 'smooth' });
    this.recherche(null);
  }


  onScrollToAnchor() {
    // this.scroller.scrollToAnchor('main');
    // setTimeout(() => {
    //   const sasa = document.getElementById("montag")
    //   sasa?.scrollIntoView({ behavior: 'smooth' })
    //   // this.scroller.scrollToAnchor("montag")
    // }, 2400);

  }
  deselectDepforsearch(selectedDepartement: Departement[]) {
    this.selectedDepartement = selectedDepartement;
  }
  onChangetypelot() {
    this.typeLotService.gettypologiebycodeType(Number(this.selectedTypeLot?.codeType)).subscribe(data => {

      this.typologiesLot = data;
    })
  }
}